/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import NorthWestOutlinedIcon from "@mui/icons-material/NorthWestOutlined";
import NorthOutlinedIcon from "@mui/icons-material/NorthOutlined";
import NorthEastOutlinedIcon from "@mui/icons-material/NorthEastOutlined";
import WestOutlinedIcon from "@mui/icons-material/WestOutlined";
import CenterFocusWeakOutlinedIcon from "@mui/icons-material/CenterFocusWeakOutlined";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import SouthWestOutlinedIcon from "@mui/icons-material/SouthWestOutlined";
import SouthOutlinedIcon from "@mui/icons-material/SouthOutlined";
import SouthEastOutlinedIcon from "@mui/icons-material/SouthEastOutlined";
import WidthFullOutlinedIcon from "@mui/icons-material/WidthFullOutlined";
import SwapVerticalCircleOutlinedIcon from "@mui/icons-material/SwapVerticalCircleOutlined";
import SwapHorizontalCircleOutlinedIcon from "@mui/icons-material/SwapHorizontalCircleOutlined";

export const IMAGE_TYPES = {
    SCALED_WIDTH: "scaled width priority",
    SCALED_HEIGHT: "scaled height priority",
    SCALED_ASPECT: "scaled aspect ratio",
    CROPPED_FOCUS: "cropped with focus area",
};
export const IMAGE_FORMAT_CROPPED = "image.format.cropped-focus";
export const IMAGE_FORMAT_SCALED = "image.format.scaled-image";
export const FORMATS = {
    CROPPED_FOCUS: { name: "Cropped Image", value: IMAGE_FORMAT_CROPPED },
    SCALED_IMAGE: { name: "Scaled Image", value: IMAGE_FORMAT_SCALED }
};

export const IMAGE_POSITION_LEFT_TOP = "left top";
export const IMAGE_POSITION_CENTER_TOP = "center top";
export const IMAGE_POSITION_RIGHT_TOP = "right top";
export const IMAGE_POSITION_LEFT_CENTER = "left center";
export const IMAGE_POSITION_CENTER_CENTER = "center center";
export const IMAGE_POSITION_RIGHT_CENTER = "right center";
export const IMAGE_POSITION_LEFT_BOTTOM = "left bottom";
export const IMAGE_POSITION_CENTER_BOTTOM = "center bottom";
export const IMAGE_POSITION_RIGHT_BOTTOM = "right bottom";
export const POSITIONS = [
    { value: IMAGE_POSITION_LEFT_TOP, name: "Left Top", icon: NorthWestOutlinedIcon },
    { value: IMAGE_POSITION_CENTER_TOP, name: "Center Top", icon: NorthOutlinedIcon },
    { value: IMAGE_POSITION_RIGHT_TOP, name: "Right Top", icon: NorthEastOutlinedIcon },
    { value: IMAGE_POSITION_LEFT_CENTER, name: "Left Center", icon: WestOutlinedIcon },
    { value: IMAGE_POSITION_CENTER_CENTER, name: "Center Center", icon: CenterFocusWeakOutlinedIcon },
    { value: IMAGE_POSITION_RIGHT_CENTER, name: "Right Center", icon: EastOutlinedIcon },
    { value: IMAGE_POSITION_LEFT_BOTTOM, name: "Left Bottom", icon: SouthWestOutlinedIcon },
    { value: IMAGE_POSITION_CENTER_BOTTOM, name: "Center Bottom", icon: SouthOutlinedIcon },
    { value: IMAGE_POSITION_RIGHT_BOTTOM, name: "Right Bottom", icon: SouthEastOutlinedIcon },
];
export const DEFAULT_POSITION = "center center";
export const ASPECT_RATIO_FULL_WIDTH = "100Aspect";
export const HEIGHT_PRIORITY = "HeightPriority";
export const WIDTH_PRIORITY = "WidthPriority";

export const METHODS = {
    ASPECT_RATIO_FULL_WIDTH,
    HEIGHT_PRIORITY,
    WIDTH_PRIORITY,
};
export const METHOD_OPTIONS = [
    { value: METHODS.ASPECT_RATIO_FULL_WIDTH, name: "Full image at 100% width", icon: WidthFullOutlinedIcon },
    { value: METHODS.HEIGHT_PRIORITY, name: "Scale using specified height", icon: SwapVerticalCircleOutlinedIcon },
    { value: METHODS.WIDTH_PRIORITY, name: "Scale using specified width", icon: SwapHorizontalCircleOutlinedIcon },
];
export const DIM_HEIGHT = "Height";
export const DIM_WIDTH = "Width";
export const DIMENSIONS = {
    DIM_WIDTH,
    DIM_HEIGHT
};
export const DEFAULT_FORMAT = IMAGE_FORMAT_CROPPED;
export const DEFAULT_METHOD = ASPECT_RATIO_FULL_WIDTH;
export const DEFAULT_SIZE = 400;
export const DEFAULT_IMAGE_SETTINGS = {
    format: DEFAULT_FORMAT,
    options: {
        useCaption: false,
        method: DEFAULT_METHOD,
        dimension: DEFAULT_SIZE,
        position: DEFAULT_POSITION,
    }
};
export const DEFAULTS = {
    DEFAULT_POSITION,
    DEFAULT_FORMAT,
    DEFAULT_METHOD,
    DEFAULT_SIZE,
    DEFAULT_IMAGE_SETTINGS
};
export const IMAGE = {
    IMAGE_TYPES,
    POSITIONS,
    METHODS,
    METHOD_OPTIONS,
    FORMATS,
    DEFAULTS,
    DIMENSIONS,
};
